export default {
  token: null,
  user: null,
  identification: null,
  identificationType: null
}
